/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../cardr/issuing/model';
import '../../bizbank/card';
import '../resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SetCardStateRequest": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "newState": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardStatus": {
                    "type": ".squareup.bizbank.cards.CardStatus",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SetCardStateResponse": {
                "fields": {
                  "card": {
                    "type": ".squareup.corporate_card.resources.Card",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetCardStateRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetCardStateResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SetCardStateRequest @ squareup/corporate_card/service/set_card_state.proto at 12:1
 */
export const SetCardStateRequest = $root.lookupType('squareup.corporate_card.service.SetCardStateRequest');
fixType(SetCardStateRequest, {
  cardToken: {
    required: true
  }
});
Builder.createAndAttachToType(SetCardStateRequest);
/**
 * SOURCE SetCardStateResponse @ squareup/corporate_card/service/set_card_state.proto at 29:1
 */
export const SetCardStateResponse = $root.lookupType('squareup.corporate_card.service.SetCardStateResponse');
fixType(SetCardStateResponse);
Builder.createAndAttachToType(SetCardStateResponse);